export const IMAGE_URL = `${process.env.REACT_APP_UPLOADED_FILE_URL}`;

export const MultiCountryFormatter = (values) => {
  // console.log('values----------->:', values)
  let str = ''
  if (values.length > 0) {

    values.map((valC, ind) => {
      console.log(valC)
      if (ind == 0) {
        str = valC.label
      } else {
        str = str + " , " + valC.label
      }
    })
  } else {
    str = "-"
  }
  return str;
  // return `${IMAGE_URL}/${value}`;
}